import { UPDATE_CURRENT_QUESTION } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_CURRENT_QUESTION:
            return action.payload
        default:
            return state
    }
}
